// ==========================================================================
// Plyr default config
// ==========================================================================

const defaults = {
  // Disable
  enabled: true,

  // Custom media title
  title: '',

  // Logging to console
  debug: false,

  // Auto play (if supported)
  autoplay: false,

  // Only allow one media playing at once (vimeo only)
  autopause: true,

  // Allow inline playback on iOS (this effects YouTube/Vimeo - HTML5 requires the attribute present)
  // TODO: Remove iosNative fullscreen option in favour of this (logic needs work)
  playsinline: true,

  // Default time to skip when rewind/fast forward
  seekTime: 10,

  // Default volume
  volume: 0.5,
  muted: false,

  limitedForward: false,

  // Pass a custom duration
  duration: null,

  // Display the media duration on load in the current time position
  // If you have opted to display both duration and currentTime, this is ignored
  displayDuration: true,

  // Invert the current time to be a countdown
  invertTime: true,

  // Clicking the currentTime inverts it's value to show time left rather than elapsed
  toggleInvert: true,

  // Force an aspect ratio
  // The format must be `'w:h'` (e.g. `'16:9'`) null
  ratio: '16:9',

  // Click video container to play/pause
  clickToPlay: true,

  // Auto hide the controls
  hideControls: true,

  // Reset to start when playback ended
  resetOnEnd: false,

  // Disable the standard context menu
  disableContextMenu: true,

  // Sprite (for icons)
  loadSprite: true,
  iconPrefix: 'starplyr',
  iconUrl: 'https://cab-starplayer.service.concdn.com/starplayer/1.0.0/starplyr.svg',

  // Blank video (used to prevent errors on source change)
  blankVideo: 'https://cab-starplayer.service.concdn.com/starplayer/1.0.0/blank.mp4',

  // Quality default
  quality: {
    default: 720,
    // The options to display in the UI, if available for the source media
    options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240],
    forced: false,
    onChange: null,
  },

  // Set loops
  loop: {
    active: false,
    // start: null,
    // end: null,
  },

  // Speed default and options to display
  speed: {
    selected: 1,
    // The options to display in the UI, if available for the source media (e.g. Vimeo and YouTube only support 0.5x-4x)
    // options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
    options: [0.6, 0.8, 1.0, 1.2, 1.4, 1.6, 1.8, 2.0],
  },

  // Keyboard shortcut settings
  keyboard: {
    focused: false,
    global: false,
  },

  // Display tooltips
  tooltips: {
    controls: false,
    seek: true,
  },

  // Captions settings
  captions: {
    active: false,
    language: 'auto',
    // Listen to new tracks added after Plyr is initialized.
    // This is needed for streaming captions, but may result in unselectable options
    update: false,
  },

  // Fullscreen settings
  fullscreen: {
    enabled: true, // Allow fullscreen?
    fallback: true, // Fallback using full viewport/window
    iosNative: false, // Use the native fullscreen in iOS (disables custom controls)
    // Selector for the fullscreen container so contextual / non-player content can remain visible in fullscreen mode
    // Non-ancestors of the player element will be ignored
    // container: null, // defaults to the player element
  },

  // Local storage
  storage: {
    enabled: true,
    key: 'starplyr',
  },

  // Default controls
  controls: [
    'play-large',
    // 'restart',
    'rewind',
    'play',
    'fast-forward',
    'progress',
    'current-time',
    'duration',
    'volume',
    'mute',
    'repeat',
    // 'captions',
    'settings',
    // 'pip',
    // 'airplay',
    // 'download',
    'fullscreen',
  ],
  settings: ['captions', 'quality', 'speed'],

  // Localisation
  i18n: {
    restart: 'Restart',
    rewind: '뒤로 {seektime}초',
    play: '재생',
    pause: '일시정지',
    fastForward: '앞으로 {seektime}초',
    seek: 'Seek',
    seekLabel: '{currentTime} of {duration}',
    played: '재생중',
    buffered: '버퍼링중',
    currentTime: 'Current time',
    duration: 'Duration',
    volume: '볼륨',
    mute: '음소거',
    unmute: '음소거 해제',
    enableCaptions: '자막',
    disableCaptions: '자막 해제',
    download: '다운로드',
    enterFullscreen: '전체화면',
    exitFullscreen: '전체화면 나가기',
    frameTitle: 'Player for {title}',
    captions: '자막',
    enableRepeat: '구간반복',
    disableRepeat: '구간반복 해제',
    settings: '설정',
    pip: 'PIP',
    menuBack: '이전 메뉴로 이동',
    speed: '배속',
    normal: '기본',
    quality: '화질',
    loop: 'Loop',
    start: '시작',
    end: '끝',
    all: '모두',
    reset: '초기화',
    disabled: '사용안함',
    enabled: '사용',
    advertisement: '광고',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      576: 'SD',
      480: 'SD',
    },
  },

  // URLs
  urls: {
    download: null,
    vimeo: {
      sdk: 'https://player.vimeo.com/api/player.js',
      iframe: 'https://player.vimeo.com/video/{0}?{1}',
      api: 'https://vimeo.com/api/oembed.json?url={0}',
    },
    youtube: {
      sdk: 'https://www.youtube.com/iframe_api',
      api: 'https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}',
    },
    googleIMA: {
      sdk: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
    },
    appStore: {
      url: 'https://apps.apple.com/kr/app/id1474597276',
    },
  },

  // Custom control listeners
  listeners: {
    seek: null,
    play: null,
    pause: null,
    restart: null,
    rewind: null,
    fastForward: null,
    mute: null,
    volume: null,
    captions: null,
    download: null,
    fullscreen: null,
    pip: null,
    airplay: null,
    speed: null,
    quality: null,
    loop: null,
    language: null,
    repeat: null,
  },

  // Events to watch and bubble
  events: [
    // Events to watch on HTML5 media elements and bubble
    // https://developer.mozilla.org/en/docs/Web/Guide/Events/Media_events
    'ended',
    'progress',
    'stalled',
    'playing',
    'waiting',
    'canplay',
    'canplaythrough',
    'loadstart',
    'loadeddata',
    'loadedmetadata',
    'timeupdate',
    'volumechange',
    'play',
    'pause',
    'error',
    'seeking',
    'seeked',
    'emptied',
    'ratechange',
    'cuechange',

    // Custom events
    'download',
    'enterfullscreen',
    'exitfullscreen',
    'captionsenabled',
    'captionsdisabled',
    'languagechange',
    'controlshidden',
    'controlsshown',
    'ready',
    'repeatenabled',
    'repeatdisabled',

    // YouTube
    'statechange',

    // Quality
    'qualitychange',

    // Ads
    'adsloaded',
    'adscontentpause',
    'adscontentresume',
    'adstarted',
    'adsmidpoint',
    'adscomplete',
    'adsallcomplete',
    'adsimpression',
    'adsclick',
  ],

  // Selectors   //controls.js findElements()에서 this.elements에 객체화 됨
  // Change these to match your template if using custom HTML
  selectors: {
    editable: 'input, textarea, select, [contenteditable]',
    container: '.plyr',
    controls: {
      container: null,
      wrapper: '.plyr__controls',
    },
    labels: '[data-plyr]',
    buttons: {
      play: '[data-plyr="play"]',
      pause: '[data-plyr="pause"]',
      restart: '[data-plyr="restart"]',
      rewind: '[data-plyr="rewind"]',
      fastForward: '[data-plyr="fast-forward"]',
      mute: '[data-plyr="mute"]',
      captions: '[data-plyr="captions"]',
      repeat: '[data-plyr="repeat"]',
      download: '[data-plyr="download"]',
      fullscreen: '[data-plyr="fullscreen"]',
      pip: '[data-plyr="pip"]',
      airplay: '[data-plyr="airplay"]',
      settings: '[data-plyr="settings"]',
      loop: '[data-plyr="loop"]',
    },
    inputs: {
      seek: '[data-plyr="seek"]',
      volume: '[data-plyr="volume"]',
      speed: '[data-plyr="speed"]',
      language: '[data-plyr="language"]',
      quality: '[data-plyr="quality"]',
    },
    display: {
      currentTime: '.plyr__time--current',
      duration: '.plyr__time--duration',
      buffer: '.plyr__progress__buffer',
      loop: '.plyr__progress__loop', // Used later
      volume: '.plyr__volume--display',
    },
    progress: '.plyr__progress',
    captions: '.plyr__captions',
    caption: '.plyr__caption',
  },

  // Class hooks added to the player in different states
  classNames: {
    type: 'plyr--{0}',
    provider: 'plyr--{0}',
    video: 'plyr__video-wrapper',
    embed: 'plyr__video-embed',
    videoFixedRatio: 'plyr__video-wrapper--fixed-ratio',
    embedContainer: 'plyr__video-embed__container',
    poster: 'plyr__poster',
    posterEnabled: 'plyr__poster-enabled',
    ads: 'plyr__ads',
    control: 'plyr__control',
    controlPressed: 'plyr__control--pressed',
    playing: 'plyr--playing',
    paused: 'plyr--paused',
    stopped: 'plyr--stopped',
    loading: 'plyr--loading',
    hover: 'plyr--hover',
    tooltip: 'plyr__tooltip',
    cues: 'plyr__cues',
    hidden: 'plyr__sr-only',
    hideControls: 'plyr--hide-controls',
    isIos: 'plyr--is-ios',
    isTouch: 'plyr--is-touch',
    uiSupported: 'plyr--full-ui',
    noTransition: 'plyr--no-transition',
    display: {
      time: 'plyr__time',
    },
    menu: {
      value: 'plyr__menu__value',
      badge: 'plyr__badge',
      open: 'plyr--menu-open',
    },
    captions: {
      enabled: 'plyr--captions-enabled',
      active: 'plyr--captions-active',
    },
    fullscreen: {
      enabled: 'plyr--fullscreen-enabled',
      fallback: 'plyr--fullscreen-fallback',
    },
    pip: {
      supported: 'plyr--pip-supported',
      active: 'plyr--pip-active',
    },
    airplay: {
      supported: 'plyr--airplay-supported',
      active: 'plyr--airplay-active',
    },
    tabFocus: 'plyr__tab-focus',
    previewThumbnails: {
      // Tooltip thumbs
      thumbContainer: 'plyr__preview-thumb',
      thumbContainerShown: 'plyr__preview-thumb--is-shown',
      thumbContainerShownWithRepeat: 'plyr__preview-thumb--is-shown-with-repeat',
      imageContainer: 'plyr__preview-thumb__image-container',
      timeContainer: 'plyr__preview-thumb__time-container',
      // Scrubbing
      scrubbingContainer: 'plyr__preview-scrubbing',
      scrubbingContainerShown: 'plyr__preview-scrubbing--is-shown',
    },
    message: 'plyr__message',
    messageEnabled: 'plyr__message-enabled',
  },

  // Embed attributes
  attributes: {
    embed: {
      provider: 'data-plyr-provider',
      id: 'data-plyr-embed-id',
    },
  },

  // Advertisements plugin
  // Register for an account here: http://vi.ai/publisher-video-monetization/?aid=plyrio
  ads: {
    enabled: false,
    publisherId: '',
    tagUrl: '',
  },

  // Preview Thumbnails plugin
  previewThumbnails: {
    enabled: false,
    src: '',
  },

  // Vimeo plugin
  vimeo: {
    byline: false,
    portrait: false,
    title: false,
    speed: true,
    transparent: false,
    // Custom settings from Plyr
    customControls: true,
    referrerPolicy: null, // https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy
    // Whether the owner of the video has a Pro or Business account
    // (which allows us to properly hide controls without CSS hacks, etc)
    premium: false,
  },

  // YouTube plugin
  youtube: {
    rel: 0, // No related vids
    showinfo: 0, // Hide info
    iv_load_policy: 3, // Hide annotations
    modestbranding: 1, // Hide logos as much as possible (they still show one in the corner when paused)
    // Custom settings from Plyr
    customControls: true,
    noCookie: false, // Whether to use an alternative version of YouTube without cookies
  },

  // StarPlayer plugin
  starplayer: {
    userId: 'ANONYMOUS',
    config: STARPLAYER_CONFIG_URL,
    logUrl: '',
    eventUrl: '',
    spkId: '',
    token: {
      enabled: false,
      url: '',
      apiKey: '',
    },
    app: {
      license: '',
      actionUrl: '',
      minimumVersionForAndroid: '1.0.0',
      minimumVersionForIos: '1.0.0',
      debug: false,
      pmp: false,
      refererReturn: true,
      offlineCheck: true,
      referer: '',
    },
    watermark: {
      enabled: true,
      text: '',
      positionChangeInterval: 10,
      displayDuration: 5,
    },
    i18n: {
      installActivex:
        "스타플레이어를 구동하려면 'StarPlayer' ActiveX 컨트롤을 설치하여 주십시오.</p><p>설치에 문제가 있으면 <a href='{activexSetupUrl}'>설치 프로그램을 다운로드</a>한 후 설치하여 주십시오.",
      installAgent:
        "스타플레이어를 구동하려면 <a href='{agentSetupUrl}'>설치 프로그램을 다운로드</a>한 후 설치하여 주십시오.",
      updateAgent:
        "스타플레이어 업데이트가 있습니다. 업데이트를 진행하려면 <a href='{agentSetupUrl}'>설치 프로그램을 다운로드</a>한 후 설치하여 주십시오.",
      installAppStore: 'StarPlayer+ 설치',
      mediaErrorAbort: '비디오 재생을 중단하였습니다.',
      mediaErrorNetwork: '네트워크 오류가 발생하였습니다.',
      mediaErrorDecode: '비디오 파일이 잘못되었거나 지원하지 않는 형식입니다.',
      mediaErrorSrcNotSupported: '비디오를 재생할 수 없습니다. 서비스 장애가 발생하였거나 지원하지 않는 형식입니다.',
      mediaErrorUnknown: '알 수 없는 오류가 발생하였습니다.',
      multipleConnections: '동일 아이디 동시 접속으로 동영상 재생이 차단되었습니다.',
      blockedUserId: '불법적 시도로 인해 아이디가 차단되었습니다.',
      blockedMachine: '불법적 시도로 인해 시스템이 차단되었습니다.',
      blockedIp: '불법적 시도로 인해 IP가 차단되었습니다.',
      blockedVmachine: '가상머신에서는 재생할 수 없습니다.',
      blockedRdesktop: '원격 데스크탑에서는 재생할 수 없습니다.',
      detectedHardware: '지원하지 않는 하드웨어 장비가 발견되었습니다.',
      detectedProcessHidder: '불법적인 시도가 감지되었습니다. 재생을 중단합니다.',
      detectedBrowserExtension: '녹화기능이 있는 브라우저 확장 프로그램이 감지되었습니다.',
      tokenError: '콘텐츠 인증정보가 정상적으로 발급되지 않았습니다.',
    },
    controllerUrl: 'http://cab-starplayer.service.concdn.com/starplayer/1.0.0/starplyr.bin',
    controller64Url: 'http://cab-starplayer.service.concdn.com/starplayer/1.0.0/starplyr_x64.bin',
  }, starplayerErrorCode: {
      MultipleConnections: 1007, 
      BlockedUID: 1008, 
      BlockedIP: 1009, 
      BlockedPID: 1010, 
      DetectHardware: 1011,
      VMACHINE: 1012, 
      RDESKTOP: 1013, 
      CanNotTerminated: 1014, 
      detectedBrowserExtension: 1015, 
      playerNotInstalled: 1016,
      needToUpdate: 1017
  }
};

export default defaults;
